// extracted by mini-css-extract-plugin
module.exports = {"inTileContainer":"video_inTileContainer__z_8ZF","consentContainer":"video_consentContainer__09gLh","fullWidthHeight":"video_fullWidthHeight__RXv7P"};